<template>
    <CustoModal 
        modalName="importModal" 
        ref="importModal" 
        @success="importFile" 
        :config="{ 
            title: pluralName,
            success: 'Enviar',
            cancel: 'Cancelar',
        }"
        :modelVerify="(form?.files?.length ?? 0) < 1"
    >
        <Upload :maxFiles="1" v-model:filesUpload="form.files" accept=".csv" messageLoadArea="Arquivos em formato CSV" />

        <slot name="body" />
    </CustoModal>
</template>

<script>
import CustoModal from "@/components/Modal/Modal.vue";
import Upload from '@/components/Upload/Upload.vue';
import UploadService from '@/services/upload-service';

export default {
    name: 'import-modal',
    components: {
        CustoModal,
        Upload,
    },
    props: {
        pluralName: { type: String, required: true },
        resourceName: { type: String, required: true },
        options: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            form: {
                files: []
            },
        }
    },
    methods: {
        async importFile() {
            await UploadService.sendCsvUpload(this.form, this, this.resourceName, this.options);
            this.$refs.importModal.closeModal();
            window.location.reload();
        },
        openModal() {
            this.$refs.importModal.openModal();
        },
    },
    emits: ['success'],
}

</script>
<style scoped>
.modal-header {
    padding: 24px;
}

.modal-title {
    font-size: 20px;
}
</style>
<style>
.modal-body {
    padding: 16px 24px 0 !important;
    margin-bottom: 0px !important;
}
</style>